module.exports = __webpack_public_path__ + "static/media/res.23b88ca2.png";